import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Badge from '@mui/material/Badge';
import VideoCameraBackOutlinedIcon from '@mui/icons-material/VideoCameraBackOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import ConstructionIcon from '@mui/icons-material/Construction';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import EngineeringIcon from '@mui/icons-material/Engineering';
import PublishOutlinedIcon from '@mui/icons-material/PublishOutlined';
import HomeIcon from '@mui/icons-material/Home';
import GradeIcon from '@mui/icons-material/Grade';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
export const Published = (status) => {
    return status 
                ? <LanguageOutlinedIcon sx={{ color: "green",fontSize:"20px" }}  />
                : <PublishOutlinedIcon sx={{ fontSize:"20px" }} color="error" />;
}

export const Special = (status) => {
    return status 
                ? <GradeIcon sx={{ color: "green",fontSize:"20px" }}  />
                : <GradeIcon sx={{ fontSize:"20px" }} color="error" />;
}

export const Featured = (status) => {
    return status 
                ? <HomeIcon sx={{ color: "green",fontSize:"20px" }}  />
                : <HomeIcon sx={{ fontSize:"20px" }} color="error" />;
}

export const Underprep = (status) => {
    return status 
                ? <ConstructionIcon sx={{ fontSize:"20px" }} color="error"  />
                : <DoneAllIcon sx={{ color: "green",fontSize:"20px" }} />;
}

export const Project = (status) => {
    return status 
                ? <EngineeringIcon sx={{ fontSize:"20px" }} color="error" />
                : <DoneAllIcon sx={{ color: "green",fontSize:"20px" }} />;
}

export const hasImages = (images) => {
    return images?.length > 0 
                ? <Badge 
                    badgeContent={images.length}  
                    color={ images.length > 1 ? 'success' : 'warning'}
                    sx={{ "& .MuiBadge-badge": { fontSize: 9, height: 15, minWidth: 15 } }}
                    >
                    <ImageOutlinedIcon color="action" />
                 </Badge>
                : <Badge 
                    badgeContent={images.length}  
                    color="error" showZero
                    sx={{ "& .MuiBadge-badge": { fontSize: 9, height: 15, minWidth: 15 } }}
                    >
                    <ImageOutlinedIcon color="action" />
                  </Badge>;
}

export const hasVideos = (videos) => {
    return videos?.length > 0 
                ? <Badge 
                    badgeContent={videos.length}  
                    color={ videos.length > 1 ? 'success' : 'warning'}
                    sx={{ "& .MuiBadge-badge": { fontSize: 9, height: 15, minWidth: 15 } }}
                    >
                    <VideoCameraBackOutlinedIcon color="action" />
                  </Badge>
                : <Badge 
                    badgeContent={videos.length}  
                    color="error" 
                    showZero 
                    sx={{ "& .MuiBadge-badge": { fontSize: 9, height: 15, minWidth: 15 } }}
                    >
                    <VideoCameraBackOutlinedIcon color="action" />
                </Badge>;
}

export const hasDescOver30 = (desc) => {
    return desc.length > 30
                ? <DescriptionOutlinedIcon sx={{ color: "green",fontSize:"20px" }}  />
                : <FiberManualRecordIcon  sx={{ fontSize:"12px" }} color="error" />;
}

export const hasFeature = (status) => {
    return status 
                ? <FiberManualRecordIcon sx={{ color: "green",fontSize:"12px" }}  />
                : <FiberManualRecordIcon sx={{ fontSize:"12px" }} color="error" />;
}